import React, {useState, forwardRef, useImperativeHandle, useEffect} from 'react';
import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {useSelector} from "react-redux";
import Switch from "react-bootstrap-switch";
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Modal, Row} from "reactstrap";


// components
import CategoryLangs from "./_categoryLangs";
import Loading from "../../../../components/loader/Loading";
import { getStateByPath } from "../../../../redux/selectors";
import { GenericButton } from "../../../../components/buttons/customButtons";
import CustomFormTitle from '../../../../components/genericComponents/CustomFormTitle';

// labels
import { INTERNATIONAL } from "../../../../components/i18n/i18n";
import { FL_ORDER } from "../../../../components/i18n/formLabels";
import { TT_CLOSE, TT_SAVE } from "../../../../components/i18n/toolTips";

// actions
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";

// service
import {categoryService} from "../../../../jwt/_services/clasificator/categoryService";
import {categoryUdnService} from "../../../../jwt/_services/park/DynamicModuleService";

//utils
import {getCurrentDateForCodeField} from "../../../../util/DateTools";



const CategoryForm = forwardRef((props, ref) => {
    const { mainPath, categoriesPath } = props

    const udnState = useSelector(state => getStateByPath(state, mainPath));
    const categoriesState = useSelector(state => getStateByPath(state, categoriesPath));

    const { app:{ fbDataBase }, domainObject:udn } = udnState?.data || {};
    const { domainObject:category, listDomainObjects:categoriesLinkedToUdn, editMode, loading } = categoriesState?.data || {};


    const [modal, setModal] = useState(false);
    const [status, setStatus] = useState( category?.status || true);
    const [langs, setLangs] = useState(category?.langs || []);
    const [isLoading, setIsLoading] = useState(false);


    const translatableLangs = category?.translatedLangs || [];


    useImperativeHandle(ref, () => ({
        showModal: () => {
            setModal(true);
        }
    }));




    const validationSchema = Yup.object().shape({});


    // Initialize the form using the useForm hook from react-hook-form.
    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: category?.id,
            showOrder: category?.showOrder,
            image: category?.image,
        }
    });





// Reinicia el formulario cuando cambie la actividad
    useEffect(() => {
        reset({
            id: category?.id,
            showOrder: category?.showOrder,
            image: category?.image,
        });

        setLangs(category?.langs || []);
    }, [category, reset]);









    const onSubmit = async (data, _) => {
        const requestData = {
            fbDataBase: { id: fbDataBase?.id },
            item: {
                ...data,
                langs,
                status,
                udn: { id: udn?.id }
            }
        }

        setIsLoading(true);


        if(editMode) {
            requestData.item.id = category?.id

            // actializar la categoría
            await categoryService.updateItem(category?.id, requestData)

            const categoryUdn = categoriesLinkedToUdn?.find(item => item?.category?.id === category?.id)

            // actualizar udn-category link
            genericIndexedActions.get(categoriesPath, categoryUdnService, categoryUdn?.id, fbDataBase?.id, closeForm)

            return
        }

        requestData.item.code = getCurrentDateForCodeField()

        const response = await categoryService.saveItem(requestData)

        const newRequestData = {
            fbDataBase: { id: fbDataBase?.id },
            item: {
                category: { id: response?.id },
                udn: { id: udn?.id }
            }
        }


        genericIndexedActions.save(categoriesPath, categoryUdnService, newRequestData, closeForm)
    }





    const closeForm = () => {
        setIsLoading(false);
        setModal(false);
    }







    return <Modal isOpen={modal} toggle={setModal} modalClassName="menu-modal-form-medium">
        <Loading isLoading={loading || isLoading}/>

        <Form  data-form="category" className="activity-form"  onSubmit={handleSubmit(onSubmit)}>
            <Card className={'card-modal'}>
                <CardTitle className="bg-light border-bottom mb-0">
                    <CustomFormTitle domainObject = { category } />
                    <div className={'top-right'}>
                        <GenericButton
                            style={'table'}
                            toolTip={TT_SAVE}
                            icon={'fa-save'}
                            permission={'add'}
                            type={'submit'}
                        />
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={closeForm}
                        />
                    </div>
                </CardTitle>

                <CardBody>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label >{ FL_ORDER }</Label>
                                <Input
                                    type="number"
                                    name="showOrder"
                                    placeholder="Orden Visualización"
                                    innerRef={register}
                                    className={(errors.showOrder ? ' is-invalid' : '')}
                                />
                                { errors.showOrder && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.showOrder?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label >Activo</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={status}
                                    onChange={_ => setStatus( !status )}
                                />
                            </FormGroup>
                        </Col>

                        <Col md="6">
                            <FormGroup>
                                <Label >Imagen</Label>
                                <Input
                                    type="text"
                                    name="image"
                                    innerRef={register}
                                    className={(errors.image ? ' is-invalid' : '')}
                                />
                                { errors.image && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.image?.message}</div>}
                            </FormGroup>
                        </Col>
                    </Row>

                    <br/>
                    <br/>

                    <Row>
                        <Col>
                            <h2>{INTERNATIONAL}</h2>
                            <br/>
                            <CategoryLangs
                                langs={langs}
                                setLangs={setLangs}
                                translatableLangs={translatableLangs}
                            />
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </Form>
    </Modal>
})

export default CategoryForm;